import * as Yup from 'yup';

export const serviceCategorySchema = Yup.object().shape({
    id: Yup.string().required('ID is required'),
    name: Yup.string().required('Name is required'),
    description: Yup.string(),
    type: Yup.string().required('Type is required'),
});
